import * as React from "react";
const WindowsMore = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={7}
    fill="none"
    {...props}
  >
    <path stroke="#fff" d="M1 6.5 6.5 1 12 6.5" />
  </svg>
);
export default WindowsMore;
